import { PulseLoader } from "halogenium";
import { useCallback, useEffect, useState } from "react";
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import iconJornal2 from '../../../assets/img/Capa Publicações - Jornal Forluz_Prancheta 1.png';
import icoAviao2 from '../../../assets/img/Capa Publicações - Newsletter_Prancheta 1.png';
import icoRentab from '../../../assets/img/capa_pub_rentabilidade_prancheta_1.png';
import icoAviao from '../../../assets/img/ico-aviao.svg';
import iconJornal from '../../../assets/img/ico-jornal.svg';
import icoSorriso from '../../../assets/img/ico-sorrisos.svg';
import api from "../../Services/api";
import "./styles.css";


// install Swiper modules
SwiperCore.use([EffectCoverflow, Pagination]);

type JornalForluzData = {
	items: any[];
	__next?: string
}

const Publicacoes = (props: any) => {

	const [busca, setBusca] = useState({ ano: "", mes: "", procura: "", categoria: "" });
	const [postagemJornalForluz, setPostagemJornal] = useState<JornalForluzData>({ items: [], __next: '' });
	const [postagemInformeTaesa, setPostagemLivros] = useState<any[]>([]);
	const [postagemNews, setPostagemNews] = useState<any[]>([]);
	const [postagemRentabilidade, setPostagemRentabilidade] = useState<any[]>([]);
	const [postagemRevistaLume, setPostagemRevistaLume] = useState<any[]>([]);
	const [notFound, setNotFound] = useState(false);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<String>();
	const [mesFilterValidation, setMesFilterValidation] = useState(true);

	const validate = useCallback(() => {

		let result = true;

		if (busca.categoria === '' && busca.ano === '' && busca.mes === '') {
			result = true;
		}
		else {
			if (((busca.categoria === '' || busca.ano === ''))) { //&& busca.mes !== ''
				result = false;
			}
			if ((busca.categoria !== '' && busca.ano === '')) {
				result = false;
			}
			if ((busca.categoria !== '' && busca.ano !== '')) {
				result = true;
			}
		}
		return result;

	}, [busca.ano, busca.categoria, busca.mes])

	useEffect(() => {

		setLoading(true);

		api
			.get("ObterPublicacoesJornalForluzFiltro")
			.then((response) => {
				setPostagemJornal({ items: response.data.results ? response.data.results : [], __next: response.data.__next });

			})
			.catch((err) => {
				throw new Error(err);
			});
		
			api
			.get("ObterPublicacoesNewsletterFiltro")
			.then((response) => {
				setPostagemNews(response.data.results)

			})
			.catch((err) => {
				throw new Error(err);
			});
		
		api
			.get("ObterPublicacoesRentabilidadesFiltro")
			.then((response) => {
				setPostagemRentabilidade(response.data.results)
			})
			.catch((err) => {
				throw new Error(err);
			});

		api
			.get("ObterPublicacoesInformeTaesaFiltro")
			.then((response) => {
				setPostagemLivros(response.data.results)

			})
			.catch((err) => {
				throw new Error(err);
			});

		api
			.get("ObterPublicacoesRevistaLumeFiltro")
			.then((response) => {
				setPostagemRevistaLume(response.data.results)

			})
			.catch((err) => {
				throw new Error(err);
			});

		setMesFilterValidation(validate());
		setLoading(false);

	}, []);


	const handleChange = (event: any) => {

		setMesFilterValidation(validate());

		const { name, value } = event.target;
		setBusca({ ...busca, [name]: value });
	};

	function handleSubmit(event: any) {

		setError("");

		event.preventDefault();

		// todos filtros vazios = retorna todos itens
		if (validate()) {
			getItems();
		}
		else {
			setError("* Preencha a categoria e o ano");
		}
	}

	function getItems() {

		let url = "";
		if (busca.ano !== "") {
			url += `Ano=${busca.ano}`;
		}
		if (busca.mes !== "") {
			url += `&Mes=${busca.mes}`;
		}
		if (busca.procura !== "") {
			url += `&Procura=${busca.procura}`;
		}

		setPostagemJornal({ items: [], __next: '' });
		setPostagemLivros([]);
		setPostagemNews([]);
		setPostagemRentabilidade([]);
		setPostagemRevistaLume([]);
		setLoading(true); // ?mes=1&ano=2022&categoriaid=1
		let setUrl;
		let category = busca.categoria.toLowerCase().replace(/ /g, "");

		if (!category && !busca.ano && !busca.mes) {
			// api
			// 	.get("ObterPublicacoesJornalForluzFiltro")
			// 	.then((response) => {
			// 		setPostagemJornal({ items: response.data.results ? response.data.results : [], __next: response.data.__next });

			// 	})
			// 	.catch((err) => {
			// 		throw new Error(err);
			// 	});

			getJornalPublicacao('ObterPublicacoesJornalForluzFiltro');
		
		api
			.get("ObterPublicacoesNewsletterFiltro")
			.then((response) => {
				setPostagemNews(response.data.results);

			})
			.catch((err) => {
				throw new Error(err);
			});

		api
			.get("ObterPublicacoesRentabilidadesFiltro")
			.then((response) => {
				setPostagemRentabilidade(response.data.results);

			})
			.catch((err) => {
				throw new Error(err);
			});

			api
				.get("ObterPublicacoesInformeTaesaFiltro")
				.then((response) => {
					setPostagemLivros(response.data.results);

				})
				.catch((err) => {
					throw new Error(err);
				});

			api
				.get("ObterPublicacoesRevistaLumeFiltro")
				.then((response) => {
					setPostagemRevistaLume(response.data.results);

				})
				.catch((err) => {
					throw new Error(err);
				});

			setLoading(false);
		}
		else {

			switch (category) {
				case "jornalforluz":
					setUrl = url ? "ObterPublicacoesJornalForluzFiltro?" : "ObterPublicacoesJornalForluzFiltro";
					break;
				case "informetaesaprev":
					setUrl = url ? "ObterPublicacoesInformeTaesaFiltro?" : "ObterPublicacoesInformeTaesaFiltro";
					break;
				case "newsletter":
					setUrl = url ? "ObterPublicacoesNewsletterFiltro?" : "ObterPublicacoesNewsletterFiltro";
					break;
				case "revistalume":
					setUrl = url ? "ObterPublicacoesRevistaLumeFiltro?" : "ObterPublicacoesRevistaLumeFiltro";
					break;
				case "rentabilidades":
					setUrl = url ? "ObterPublicacoesRentabilidadesFiltro?" : "ObterPublicacoesRentabilidadesFiltro";
					break;
				default:
					setUrl = "";
					break;
			}

			api.get(setUrl + url).then((response) => {
				if (response.data.results.length === 0) {
					setNotFound(true);
					setLoading(false);
				} else {
					setNotFound(false);
					setLoading(true);
					switch (busca.categoria) {

						case "Jornal Forluz":
							setPostagemJornal({ items: response.data.results ? response.data.results : [], __next: response.data.__next });
							break;
						case "Informe Taesa":
							setPostagemLivros(response.data.results);
							break;
						case "Informe Taesaprev":
							setPostagemLivros(response.data.results);
							break;
						case "Newsletter":
							setPostagemNews(response.data.results);
							break;
						case "Rentabilidades":
							setPostagemRentabilidade(response.data.results);
							break;
						case "Revista Lume":
							setPostagemRevistaLume(response.data.results);
							break;
						default:
							setUrl = "";
							break;
					}

					setLoading(false);

				}

			}).catch(error => {
				throw new Error(error);
			}
			);
		}
	}

	function handleImage(x: any) {
		const imgArray = [iconJornal, icoAviao, icoSorriso];
		let pos = x % 3;
		return imgArray[pos];
	}


	let years: any[] = [];
	for (let i = 2010; i <= new Date().getFullYear(); i++) {
		years.push(i);
	}
	//invert years array
	years = years.reverse();
	
	function formatDateAno(dateUtc: any) {
		if (dateUtc) {
				let month = new Date(dateUtc).toLocaleString('pt-BR', { month: 'long' });
				month = month.charAt(0).toUpperCase() + month.slice(1);
				return month + ' ' + new Date(dateUtc).getFullYear().toString();
		}
}

	function getIconeType(url: any) {
		let _url = "";

		if (url.indexOf("/Jornal Forluz/") > 0) {
			_url = iconJornal2;
		}
		else if (url.indexOf("/Newsletter/") > 0) {
			_url = icoAviao2;
		}
		else if (url.indexOf("/Rentabilidades/") > 0) {

			_url = icoRentab;
		}
		else {
			_url = icoSorriso;
		}
		return _url;
	}

	function getJornalPublicacao(url: string) {
		console.log(url);
		api
			.get(url)
			.then((response) => {
				// let _items = [];
				// _items = postagemJornalForluz?.items ? postagemJornalForluz?.items?.concat(response.data.results) : [];

				// console.log(_items);
				setPostagemJornal({ items: response.data.results ? response.data.results : [], __next: response.data.__next });

			})
			.catch((err) => {
				throw new Error(err);
			});
	}


	//arrows
	const [swiperIndex, setSwiperIndex] = useState(0);

	const handlePrevClick = () => {
		setSwiperIndex((prevIndex) => prevIndex - 1);
	};

	const handleNextClick = () => {

		if (postagemJornalForluz?.__next) {
			getJornalPublicacao(postagemJornalForluz?.__next);
		}
		setSwiperIndex((prevIndex) => prevIndex + 1);
	}

	const isPrevDisabled = swiperIndex === 0; // Disable prev button when swiperIndex is 0
	const isNextDisabled = swiperIndex === postagemJornalForluz?.items?.length; // Disable next button when swiperIndex is at the maximum



	//arrows
	const [swiperIndex2, setSwiperIndex2] = useState(0);

	const handlePrevClick2 = () => {
		setSwiperIndex2((prevIndex) => prevIndex - 1);
	};

	const handleNextClick2 = () => {
		setSwiperIndex2((prevIndex) => prevIndex + 1);
	};

	const isPrevDisabled2 = swiperIndex2 === 0; // Disable prev button when swiperIndex is 0
	const isNextDisabled2 = swiperIndex2 === postagemNews.length; // Disable next button when swiperIndex is at the maximum




	//arrows
	const [swiperIndex3, setSwiperIndex3] = useState(0);

	const handlePrevClick3 = () => {
		setSwiperIndex3((prevIndex) => prevIndex - 1);
	};

	const handleNextClick3 = () => {
		setSwiperIndex3((prevIndex) => prevIndex + 1);
	};

	const isPrevDisabled3 = swiperIndex3 === 0; // Disable prev button when swiperIndex is 0
	const isNextDisabled3 = swiperIndex3 === postagemInformeTaesa.length; // Disable next button when swiperIndex is at the maximum



	//arrows
	const [swiperIndex4, setSwiperIndex4] = useState(0);

	const handlePrevClick4 = () => {
		setSwiperIndex4((prevIndex) => prevIndex - 1);
	};

	const handleNextClick4 = () => {
		setSwiperIndex4((prevIndex) => prevIndex + 1);
	};

	const isPrevDisabled4 = swiperIndex4 === 0; // Disable prev button when swiperIndex is 0
	const isNextDisabled4 = swiperIndex4 === postagemRevistaLume.length; // Disable next button when swiperIndex is at the maximum



	return (
		<>

			<><div className="_the-content page-comunicados pb-10">
				<div className='container d-lg-block mt-9'>
					<div className="row justify-content-center">

						<div className="col-lg-10 col-xl-9">
							<h3 className="mb-5"> Filtro </h3>
							<form className="_form">
								<div className="row">
									<div className="col-12 col-md-4 col-xl-5 mb-3 mb-lg-0">
										<span style={{
											fontWeight: 'bold',
											bottom: '-46%',
											left: '-10px',
											position: 'relative',
											color: 'rgb(232, 116, 0)',
										}}>*</span>
										<label className="select" htmlFor="mes">

											<select onChange={e => handleChange(e)} id="categoria" name="categoria">
												<option value="" >Categoria</option>
												<option value="Jornal Forluz" >Jornal Forluz</option>
												<option value="Revista Lume" >Revista Lume</option>
												<option value="Newsletter" >Newsletter</option>
												<option value="Rentabilidades" >Rentabilidade</option>
												<option value="Informe Taesaprev" >Informe Taesaprev</option>
											</select>

											<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M7.00072 5.17192L11.9507 0.221924L13.3647 1.63592L7.00072 7.99992L0.636719 1.63592L2.05072 0.221924L7.00072 5.17192Z" fill="#727272" />
											</svg>

										</label>
									</div>
									<div className="col-6 col-md-4 col-xl-3 mb-3 mb-lg-0">
										<span style={{
											fontWeight: 'bold',
											bottom: '-46%',
											left: '-10px',
											position: 'relative',
											color: 'rgb(232, 116, 0)',
										}}>*</span>
										<label className="select" htmlFor="ano">
											<select onChange={e => handleChange(e)} id="ano" name="ano">
												<option value="" >Ano</option>
												{years?.map((year, index) => (
													<option key={index} value={year}>{year}</option>
												))}
											</select>
											<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M7.00072 5.17192L11.9507 0.221924L13.3647 1.63592L7.00072 7.99992L0.636719 1.63592L2.05072 0.221924L7.00072 5.17192Z" fill="#727272" />
											</svg>
										</label>
									</div>
									<div className="col-6 col-md-2">
										<span style={{
											fontWeight: 'bold',
											bottom: '-46%',
											left: '-10px',
											position: 'relative',
											color: 'rgb(232, 116, 0)',
											visibility: mesFilterValidation ? 'visible' : 'hidden'
										}}>&nbsp;</span>
										<label className="select" htmlFor="mes">

											<select onChange={e => handleChange(e)} id="mes" name="mes" >
												<option value="" >Mês</option>
												<option value="1">Janeiro</option>
												<option value="2">Fevereiro</option>
												<option value="3">Março</option>
												<option value="4">Abril</option>
												<option value="5">Maio</option>
												<option value="6">Junho</option>
												<option value="7">Julho</option>
												<option value="8">Agosto</option>
												<option value="9">Setembro</option>
												<option value="10">Outubro</option>
												<option value="11">Novembro</option>
												<option value="12">Dezembro</option>
											</select>

											<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M7.00072 5.17192L11.9507 0.221924L13.3647 1.63592L7.00072 7.99992L0.636719 1.63592L2.05072 0.221924L7.00072 5.17192Z" fill="#727272" />
											</svg>

										</label>

									</div>
									<div className="col-12 col-lg-2">
										<button onClick={handleSubmit} type="submit" className="btn btn-filter icon rounded" style={{ position: "relative", bottom: "-25px" }}>
											<span className="d-lg-none mr-4">
												Buscar
											</span>
											<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
												<path d="M15 15L12 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
											</svg>
										</button>
									</div>
									<span style={{
										fontWeight: 'bold',
										marginBlockStart: '15px',
										position: 'relative',
										left: '10px',
										color: 'rgb(232, 116, 0)',
										bottom: '-24px',
									}}>{error}</span>
								</div>

							</form>

							<hr className="mt-8 mb-5" />
						</div>
					</div>
				</div>
			</div>{notFound && <div className="container" id="notFound" style={{ position: "relative", left: "1%" }}>
				<div className="row justify-content-center">
					<div className="col-lg-10">
						<div className="tabs mb-6 pt-8">
							<div className='row align-items-strech' style={{ textAlign: 'center', display: 'block' }}>
								<h3>Oops! Não encontramos nada.</h3>
							</div>
						</div>
					</div>
				</div>
			</div>}</>

			<>
				{loading && <div className="container" id="loading" style={{ position: "relative", left: "25%" }}>
					<div className="row justify-content-center">
						<div className="col-lg-10">
							<div className="tabs mb-6 pt-8">
								<div className='row align-items-strech'>

									<PulseLoader size={20} color="#E87400" margin="4px" />
								</div>
							</div>
						</div>
					</div>
				</div>}
				{notFound === false && <>

					{postagemJornalForluz && (postagemJornalForluz?.items?.length ? postagemJornalForluz?.items.length : 0) > 0 &&
						<section key={new Date().getTime()} className="_carousel-posts">

							<div className="container">
								<div className="row justify-content-center">
									<div className="col-lg-9">
										<h3 className="mb-7"> Jornal Forluz </h3>
									</div>
									<div className="col-lg-9">
										<div className="row loaded">
											<div className="swiper-wrapper">
												{
													<Swiper
														grabCursor={true}
														slidesPerView={"auto"}
														pagination={false}
														initialSlide={swiperIndex}
														breakpoints={{
															// 384: {
															// 	width: 384,
															// 	slidesPerView: 2,
															// },
															590: {
																// width: 500,
																slidesPerView: 3,
															},
															// 1200: {
															// 	width: 1200,
															// 	slidesPerView: 3,
															// },
														}}
													>
														{postagemJornalForluz?.items?.map((item: any, index: any) => (
															<SwiperSlide key={item.ID}>
																{console.log(item)}
																<div key={item.ID} id={"DIV_" + item.ID} className='swiper-slide col-lg-4 col-md-6 load-post border' >

																	<div className="card-noticia pr-md-3 pl-lg-4" >
																		<div className="card-publicacao h-100">
																			<a rel="noreferrer" href={item.URL} target="_blank">
																				<div className="card-publicacao__topo">
																					<h4>
																						{`Nº ${item.ID} - ${formatDateAno(item.Data_x0020_Publicacao)}`}
																					</h4>
																					<h3>
																						
																					</h3>
																				</div>
																				<div className="card-publicacao__img card-publicacao__img3 bg-primary  mx-xl-0">
																					<img src={getIconeType(item?.URL)} alt="ícone" />
																				</div>

																				<div className="card-publicacao__text">
																					<p className="text-medium">
																						{item.Descricao}
																					</p>
																				</div>
																				<div className="card-publicacao__link  d-none d-lg-block">

																					<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path d="M5 1V9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																						<path d="M1 5H9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																					</svg>
																				</div>
																			</a>
																		</div>
																	</div>
																</div>
															</SwiperSlide>
														))}


													</Swiper>
												}

											</div>

										</div>

										<div className="col-12 d-lg-none mb-10">
											<div className="d-flex align-items-center justify-content-end mt-10">
												<div className={`swiper-button-prev swiper-button publicacoes-prev ${isPrevDisabled ? 'swiper-button-disabled' : ''}`}>
													<svg onClick={handlePrevClick} className="swiper-arrow swiper-arrow-prev" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
													</svg>
												</div>
												<div className="arrow-w">
												<div className={`swiper-button-next swiper-button noticias-next ${isNextDisabled ? 'swiper-button-disabled' : ''}`}>
													<svg onClick={handleNextClick} className="swiper-arrow swiper-arrow-next" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
													</svg>
												</div>
												</div>
											</div>
										</div>

										<hr className="mt-8 mb-5" />
									</div>

								</div>

							</div>

						</section>}

					{postagemNews && postagemNews.length > 0 &&
						<section key={new Date().getTime() + 1} className="_carousel-posts">

							<div className="container">
								<div className="row justify-content-center">
									<div className="col-lg-9">
										<h3 className="mb-7"> Newsletter </h3>
									</div>

									<div className="col-lg-9">
										<div className="row loaded">
											<div className="swiper-wrapper">
												{<Swiper

													grabCursor={true}
													slidesPerView={"auto"}
													pagination={false}
													initialSlide={swiperIndex2}
													breakpoints={{
													// 	384: {
													// 		width: 384,
													// 		slidesPerView: 2,
													// 	},
														590: {
															// width: 500,
															slidesPerView: 3,
														},
													// 	// 1200: {
													// 	// 	width: 1200,
													// 	// 	slidesPerView: 3,
													// 	// },
													}}
												>
													{postagemNews?.map((item: any, index: any) => (
														<SwiperSlide key={index}>
															<div key={index} id={"DIV_" + index} className="swiper-slide col-lg-4 col-md-6 load-post border">
																<div className="card-noticia pr-md-3 pl-lg-4" >
																	<div className="card-publicacao h-100">
																		<a rel="noreferrer" href={item.URL} target="_blank">
																			<div className="card-publicacao__topo">
																				<h4>
																					{`Nº ${item.ID} - ${formatDateAno(item.Data_x0020_Publicacao)}`}
																				</h4>
																			</div>
																			<div className="card-publicacao__img card-publicacao__img3 box3 mx-xl-0">
																				<img src={getIconeType(item?.URL)} alt="ícone" />
																			</div>

																			<div className="card-publicacao__text">
																				<p className="text-medium">
																					{item.Descricao}
																				</p>
																			</div>
																			<div className="card-publicacao__link  d-none d-lg-block">

																				<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
																					<path d="M5 1V9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																					<path d="M1 5H9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																				</svg>

																			</div>
																		</a>
																	</div>
																</div>
															</div>
														</SwiperSlide>
													))}


												</Swiper>
												}
											</div>

										</div>

										<div className="col-12 d-lg-none mb-10">
											<div className="d-flex align-items-center justify-content-end mt-10">
												<div className={`swiper-button-prev swiper-button publicacoes-prev ${isPrevDisabled2 ? 'swiper-button-disabled' : ''}`}>
													<svg onClick={handlePrevClick2} className="swiper-arrow swiper-arrow-prev" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
													</svg>
												</div>
												<div className="arrow-w">
												<div className={`swiper-button-next swiper-button noticias-next ${isNextDisabled ? 'swiper-button-disabled' : ''}`}>
													<svg onClick={handleNextClick} className="swiper-arrow swiper-arrow-next" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
													</svg>
												</div>
												</div>
											</div>
										</div>

										<hr className="mt-8 mb-5" />
									</div>

								</div>
							</div>
						</section>}

						{postagemRentabilidade && postagemRentabilidade.length > 0 &&
						<section key={new Date().getTime() + 2} className="_carousel-posts">

							<div className="container">
								<div className="row justify-content-center">
									<div className="col-lg-9">
										<h3 className="mb-7">Rentabilidade</h3>
									</div>

									<div className="col-lg-9">
										<div className="row loaded">
											<div className="swiper-wrapper">
												{<Swiper

													grabCursor={true}
													slidesPerView={"auto"}
													pagination={false}
													initialSlide={swiperIndex2}
													breakpoints={{
													// 	384: {
													// 		width: 384,
													// 		slidesPerView: 2,
													// 	},
														590: {
															// width: 500,
															slidesPerView: 3,
														},
													// 	// 1200: {
													// 	// 	width: 1200,
													// 	// 	slidesPerView: 3,
													// 	// },
													}}
												>
													{postagemRentabilidade?.map((item: any, index: any) => (
														<SwiperSlide key={index}>
															<div key={index} id={"DIV_" + index} className="swiper-slide col-lg-4 col-md-6 load-post border">
																<div className="card-noticia pr-md-3 pl-lg-4" >
																	<div className="card-publicacao h-100">
																		<a rel="noreferrer" href={item.URL} target="_blank">
																			<div className="card-publicacao__topo">
																				<h4>
																					{`Nº ${item.ID} - ${formatDateAno(item.Data_x0020_Publicacao)}`}
																				</h4>
																			</div>
																			<div className="card-publicacao__img card-publicacao__img3 box3 mx-xl-0">
																				<img src={getIconeType(item?.URL)} alt="ícone" />
																			</div>

																			<div className="card-publicacao__text">
																				<p className="text-medium">
																					{item.Descricao}
																				</p>
																			</div>
																			<div className="card-publicacao__link  d-none d-lg-block">

																				<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
																					<path d="M5 1V9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																					<path d="M1 5H9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																				</svg>

																			</div>
																		</a>
																	</div>
																</div>
															</div>
														</SwiperSlide>
													))}
												</Swiper>
												}
											</div>
										</div>

										<div className="col-12 d-lg-none mb-10">
											<div className="d-flex align-items-center justify-content-end mt-10">
												<div className={`swiper-button-prev swiper-button publicacoes-prev ${isPrevDisabled2 ? 'swiper-button-disabled' : ''}`}>
													<svg onClick={handlePrevClick2} className="swiper-arrow swiper-arrow-prev" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
													</svg>
												</div>
												<div className="arrow-w">
												<div className={`swiper-button-next swiper-button noticias-next ${isNextDisabled ? 'swiper-button-disabled' : ''}`}>
													<svg onClick={handleNextClick} className="swiper-arrow swiper-arrow-next" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
													</svg>
												</div>
												</div>
											</div>
										</div>

										<hr className="mt-8 mb-5" />
									</div>

								</div>
							</div>
						</section>}

					{postagemInformeTaesa && postagemInformeTaesa.length > 0 &&
						<section key={new Date().getTime() + 3} className="_carousel-posts">

							<div className="container">
								<div className="row justify-content-center">
									<div className="col-lg-9">
										<h3 className="mb-7"> Informe Taesaprev </h3>
									</div>

									<div className="col-lg-9">
										<div className="row loaded">
											<div className="swiper-wrapper">
												<Swiper

													grabCursor={true}
													slidesPerView={"auto"}
													pagination={false}
													initialSlide={swiperIndex3}
													breakpoints={{
														// 384: {
														// 	width: 384,
														// 	slidesPerView: 2,
														// },
														590: {
															// width: 500,
															slidesPerView: 3,
														},
														// 1200: {
														// 	width: 1200,
														// 	slidesPerView: 3,
														// },
													}}
												>
													{postagemInformeTaesa?.map((item: any, index: any) => (
														<SwiperSlide key={index}>
															<div key={index} id={"DIV_" + index} className='swiper-slide col-lg-4 col-md-6 load-post border' >
																<div className="card-publicacao h-100">
																	<a rel="noreferrer" href={item.URL} target="_blank">
																		<div className="card-publicacao__topo">
																			<h4>
																				{/* Nº {item.ID} <br /> */}
																				{`Nº ${item.ID} - ${formatDateAno(item.Data_x0020_Publicacao)}`}
																			</h4>
																		</div>
																		<div className="card-publicacao__img card-publicacao__img3 bg-primary mx-xl-0">
																			<img src={handleImage(index)} alt="ícone" />
																			{/* <img src={getIconeType(item?.URL)} alt="ícone" /> */}
																		</div>

																		<div className="card-publicacao__text">
																			<p className="text-medium">
																				{item.Descricao}
																			</p>
																		</div>
																		<div className="card-publicacao__link  d-none d-lg-block">

																			<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
																				<path d="M5 1V9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																				<path d="M1 5H9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																			</svg>

																		</div>
																	</a>
																</div>
															</div>
														</SwiperSlide>
													))}


												</Swiper>

											</div>

										</div>
										<div className="col-12 d-lg-none mb-10">
											<div className="d-flex align-items-center justify-content-end mt-10">
												<div className={`swiper-button-prev swiper-button publicacoes-prev ${isPrevDisabled3 ? 'swiper-button-disabled' : ''}`}>
													<svg onClick={handlePrevClick3} className="swiper-arrow swiper-arrow-prev" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
													</svg>
												</div>
												<div className="arrow-w">
												<div className={`swiper-button-next swiper-button noticias-next ${isNextDisabled ? 'swiper-button-disabled' : ''}`}>
													<svg onClick={handleNextClick} className="swiper-arrow swiper-arrow-next" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
													</svg>
												</div>
												</div>
											</div>
										</div>
										<hr className="mt-8 mb-5" />
									</div>

								</div>

							</div>

						</section>}

					{postagemRevistaLume && postagemRevistaLume.length > 0 &&
						<section key={new Date().getTime() + 4} className="_carousel-posts">

							<div className="container">
								<div className="row justify-content-center">
									<div className="col-lg-9">
										<h3 className="mb-7"> Revista Lume </h3>
									</div>

									<div className="col-lg-9">
										<div className="row loaded">
											<div className="swiper-wrapper">
												<Swiper

													grabCursor={true}
													slidesPerView={"auto"}
													pagination={false}
													initialSlide={swiperIndex4}
													breakpoints={{
														// 384: {
														// 	width: 384,
														// 	slidesPerView: 2,
														// },
														590: {
															// width: 620,
															slidesPerView: 3,
														},
														// 1200: {
														// 	width: 1200,
														// 	slidesPerView: 3,
														// },
													}}
												>
													{postagemRevistaLume?.map((item: any, index: any) => (
														<SwiperSlide key={index}>
															<div key={index} id={"DIV_" + index} className='swiper-slide col-lg-4 col-md-6 load-post border' >
																<div className="card-publicacao h-100">
																	<a rel="noreferrer" href={item.URL} target="_blank">
																		<div className="card-publicacao__topo">
																			<h4>
																				{/* Nº {item.ID} <br /> */}
																				{`Nº ${item.ID} - ${formatDateAno(item.Data_x0020_Publicacao)}`}
																			</h4>
																		</div>
																		<div className="card-publicacao__img card-publicacao__img3 bg-primary mx-xl-0">
																			<img src={handleImage(index)} alt="ícone" />
																			{/* <img src={getIconeType(item?.URL)} alt="ícone" /> */}
																		</div>

																		<div className="card-publicacao__text">
																			<p className="text-medium">
																				{item.Descricao}
																			</p>
																		</div>
																		<div className="card-publicacao__link  d-none d-lg-block">

																			<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
																				<path d="M5 1V9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																				<path d="M1 5H9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																			</svg>

																		</div>
																	</a>
																</div>
															</div>
														</SwiperSlide>
													))}


												</Swiper>

											</div>

										</div>
										<div className="col-12 d-lg-none mb-10">
											<div className="d-flex align-items-center justify-content-end mt-10">
												<div className={`swiper-button-prev swiper-button publicacoes-prev ${isPrevDisabled4 ? 'swiper-button-disabled' : ''}`}>
													<svg onClick={handlePrevClick4} className="swiper-arrow swiper-arrow-prev" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
													</svg>
												</div>
												<div className="arrow-w">
												<div className={`swiper-button-next swiper-button noticias-next ${isNextDisabled ? 'swiper-button-disabled' : ''}`}>
													<svg onClick={handleNextClick} className="swiper-arrow swiper-arrow-next" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
													</svg>
												</div>
												</div>
											</div>
										</div>
										<hr className="mt-8 mb-5" />
									</div>

								</div>
							</div>
						</section>}
				</>
				}
			</>
		</>
	);
};
export default Publicacoes;
